import Button from './button';
import CloseButtonEvent from './close-button-event';

/**
 * A button that closes something, and says what.
 *
 * `dispatcher` names what it closes, and goes out on the {@link CloseButtonEvent} it answers a press with, so one listener can serve every CloseButton below it. Empty until it is set, which a listener can read as a button nobody said anything about.
 */
export default class CloseButton extends Button {
	public dispatcher: string;

	public constructor() {
		super();
		this.dispatcher = '';
		this.icon = 'x-close';
		this.text = 'Luk';
	}

	/**
	 * Answers the press with its own event.
	 *
	 * Super.clicked() is deliberately not called: Button answers a press with a ButtonEvent, and a listener above would hear both that and this one, without being able to tell which button the ButtonEvent came from.
	 */
	protected override clicked(): void {
		this.dispatchEvent(new CloseButtonEvent(this.dispatcher));
	}
}
customElements.define('ac-close-button', CloseButton);
